//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DeleteExpiredExternalReferencesInMsp: FeatureFlag = {"Id":"DeleteExpiredExternalReferencesInMsp","Label":"Delete purged/expired external references in MSP","Impact":"Legacy. To be removed. Don't change","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
